module.exports = __webpack_public_path__ + "img/pr-4.b0bbfa52.png";